import {WidgetData} from '../../../core/shared/widget/widget-data';
import {WidgetFactory} from '../../../core/shared/widget/service/widget.factory';
import {FilterCriteria} from '../../../core/shared/filter/api/filter.criteria';
import {Sorting} from '../../../core/shared/misc/sorting';
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from '../../../core/shared/helper/widget-function-call-back-create';

/**
 * Alias of the "Gesellschaften" child widget of a request type.
 *
 * TRAP CONFIG-011: ONE alias across every state of the widget. A per-selection alias makes the
 * stored column widths/sortings of the variants overwrite each other.
 */
export const CW_REQUEST_TYPE_PARTNER_WIDGET_ALIAS = 'config.cw.CwRequestTypePartner.widget';

/**
 * Builds the "Gesellschaften" child table of one {@code cw.CwRequestType} (T3 FE-09) — the
 * insurers admissible for the selected intake type plus their recognition hints.
 *
 * TRAP CONFIG-012: the parent FK is pre-set on CREATE through
 * {@code functionCallbacks.onFunctionCreateNew}. Without it the inline create dialog opens with
 * an EMPTY Antragstyp, the user picks the wrong one (or none), and the row ends up under a
 * different parent than the table it was created from.
 *
 * @param requestTypeId id of the selected parent {@code cw.CwRequestType}.
 */
export function buildCwRequestTypePartnerWidget(requestTypeId: number): WidgetData {
    /**
     * AI:
     * Status: "in progress"
     * Type: Widget
     * SubType: Runtime
     * Reason: Child table of one CwRequestType's admissible Gesellschaften, parent FK pre-set on
     *   CREATE via WidgetFunctionCallBackCreate (CONFIG-012).
     */
    const widgetData = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
        CW_REQUEST_TYPE_PARTNER_WIDGET_ALIAS,
        'Gesellschaften',
        'cw.CwRequestTypePartner',
        [FilterCriteria.create('e.requestTypeId', FilterCriteria.cOperatorEqual, requestTypeId)],
        [new Sorting('e.orderPriority', true)]
    );
    widgetData.noDataText = 'Keine Gesellschaften für diesen Antragstyp konfiguriert';

    const fields: WidgetToolbarCreateInterface[] = [{fieldName: 'requestTypeDtoId', fieldValue: requestTypeId}];
    widgetData.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);

    return widgetData;
}
